import React from 'react';

const PrivacyPolicy: React.FC = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 to-indigo-100">
      <div className="container mx-auto px-4 py-16">
        <div className="max-w-4xl mx-auto bg-white rounded-lg shadow-lg p-8">
          <h1 className="text-3xl font-bold text-gray-900 mb-8">Informativa sulla Privacy</h1>
          <p className="text-sm text-gray-600 mb-8">Ultimo aggiornamento: 25-07-2025</p>

          <div className="prose prose-lg max-w-none">
            <p className="text-gray-700 mb-6">
              Il sito <b>vogliolafibra.ciccilleju.it</b> (di seguito "il Sito") rispetta la privacy dei propri utenti e si impegna a proteggere i dati personali forniti durante l'utilizzo del servizio.
            </p>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">Natura del Servizio</h2>
              <div className="bg-blue-50 border-l-4 border-blue-500 p-6 rounded-r-lg">
                <p className="text-gray-700 mb-4">
                  <strong>Servizio Completamente Gratuito:</strong> Questo sito web è fornito gratuitamente come servizio alla comunità. Non sono presenti banner pubblicitari, popup, tracciamento per scopi commerciali o qualsiasi forma di monetizzazione.
                </p>
                <p className="text-gray-700 mb-4">
                  <strong>Finalità Sociale:</strong> L'unico scopo di questa piattaforma è offrire un servizio utile alla comunità per segnalare e monitorare i disservizi della connessione internet in Italia, identificando zone d'ombra nella copertura fibra, problemi di cablatura (come civici adiacenti coperti mentre altri no, apparentemente per errore o valutazioni incomplete), e altre problematiche simili.
                </p>
                <p className="text-gray-700 mb-4">
                  <strong>Nessun Contatto Diretto con Operatori:</strong> È importante chiarire che il gestore di questo sito <u>non ha alcun contatto diretto con gli operatori di telecomunicazioni</u>. Il sito funge esclusivamente da piattaforma di raccolta segnalazioni da parte degli utenti. Si auspica che, qualora le segnalazioni in una specifica zona dovessero diventare numerose, gli operatori interessati possano autonomamente prenderne visione e procedere con una rivalutazione o un esame approfondito della zona segnalata.
                </p>
                <p className="text-gray-700 mb-4">
                  <strong>Nessun Intento di Lucro:</strong> Il gestore del sito non intende trarre alcun profitto economico da questo servizio. Tutti i costi di gestione e mantenimento sono sostenuti personalmente senza alcun ritorno economico.
                </p>
                <p className="text-gray-700">
                  <strong>Impegno alla Conformità:</strong> Nel caso in cui dovessi inavvertitamente infrangere qualche regola o normativa, mi impegno a provvedere immediatamente alla correzione del problema o, se necessario, alla rimozione completa del sito.
                </p>
              </div>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">1. Tipi di dati raccolti</h2>
              <p className="text-gray-700 mb-4">Il Sito raccoglie solo ed esclusivamente i seguenti dati:</p>
              <ul className="list-disc pl-6 text-gray-700 mb-4">
                <li><strong>Username</strong></li>
                <li><strong>Password</strong> (memorizzata in forma criptata)</li>
              </ul>
              <p className="text-gray-700">
                Non vengono raccolti nome, cognome, indirizzo email, numero di telefono o altri dati personali identificativi.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">2. Finalità del trattamento</h2>
              <p className="text-gray-700 mb-4">I dati raccolti sono utilizzati esclusivamente per:</p>
              <ul className="list-disc pl-6 text-gray-700">
                <li>Permettere all'utente di registrarsi ed effettuare l'accesso al Sito</li>
                <li>Consentire la segnalazione anonima di disservizi su mappa</li>
              </ul>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">3. Base giuridica del trattamento</h2>
              <p className="text-gray-700">
                Il trattamento dei dati è basato sul <strong>consenso dell'utente</strong>, espresso al momento della registrazione, e sull'esecuzione di misure precontrattuali o contrattuali legate all'uso del servizio.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">4. Conservazione dei dati</h2>
              <p className="text-gray-700">
                I dati sono conservati per il tempo strettamente necessario a garantire il funzionamento del servizio. La password è memorizzata in forma criptata e non è accessibile in chiaro da nessuno.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">5. Cookie</h2>
              <p className="text-gray-700 mb-4">
                Il Sito <strong>non utilizza cookie di profilazione o tracciamento</strong>.
              </p>
              <p className="text-gray-700 mb-4">
                Possono essere utilizzati <strong>cookie tecnici</strong> per il corretto funzionamento della sessione utente.
              </p>
              <p className="text-gray-700">
                <strong>Nota su Google Maps</strong>: il Sito potrebbe integrare mappe tramite le API di Google Maps. Google potrebbe impostare cookie di terze parti. Per ulteriori informazioni, si rimanda alla{' '}
                <a
                  href="https://policies.google.com/privacy"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-blue-600 hover:text-blue-800 underline"
                >
                  Privacy Policy di Google
                </a>.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">6. Diritti dell'utente</h2>
              <p className="text-gray-700 mb-4">L'utente ha diritto di:</p>
              <ul className="list-disc pl-6 text-gray-700 mb-4">
                <li>Accedere ai propri dati</li>
                <li>Chiedere la rettifica o cancellazione dei propri dati</li>
                <li>Revocare il consenso al trattamento, ove applicabile</li>
              </ul>
              <p className="text-gray-700">
                Per esercitare i propri diritti, è possibile contattare il gestore del sito tramite email all'indirizzo francesco @ ciccilleju . it
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">7. Titolare del trattamento</h2>
              <p className="text-gray-700 mb-4">Il titolare del trattamento dei dati è:</p>
              <div className="bg-gray-50 p-4 rounded-lg">
                <p className="text-gray-600 italic">"Nessun contatto diretto disponibile"</p>
              </div>
            </section>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;